import { tsrContractsClient } from '../tsrContractsClient';

export const patientAssessmentsClient = () => tsrContractsClient.patientAssessmentContract;
